import { TiSocialFacebook } from "react-icons/ti";
import { FaYoutube } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";

export default function TopBar() {
  return (
    <div className="bg-[#1A3617] text-white text-xs">
      <div className="container mx-auto  flex-col hidden md:flex md:flex-row items-center justify-between h-[40px] px-10 py-2">
        <div className="mb-1 md:mb-0 flex items-center gap-4">
          <span className="inline-block w-[1px] h-[40px] bg-[#8B8B8B]"></span>
          <span className="text-[#8B8B8B]">
            Your Trusted 24 Hours Service Provider
          </span>
          <span className="inline-block w-[1px] h-[40px] bg-[#8B8B8B]"></span>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:space-x-4">
          <div className="flex items-center space-x-4">
            <span className="inline-block w-[1px] h-[40px] bg-[#8B8B8B]"></span>
            <span className="text-[#8B8B8B]">
              Office Hour : 8:00am - 6:00pm
            </span>
            <span className="inline-block w-[1px] h-[40px] bg-[#8B8B8B]"></span>
          </div>
          <div className="flex items-center space-x-2">
            <TiSocialFacebook size={20} className="text-[#8B8B8B]" />
            <FaYoutube size={16} className="text-[#8B8B8B]" />
            <FaInstagramSquare size={16} className="text-[#8B8B8B]" />
            <FaLinkedinIn size={16} className="text-[#8B8B8B]" />
          </div>
          <span className="inline-block w-[1px] h-[40px] bg-[#8B8B8B]"></span>
        </div>
      </div>
    </div>
  );
}
